function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "6cria",
  d: "M716 3734.276c0-6.227-4.91-11.276-10.97-11.276-6.06 0-10.457 4.875-10.97 11.08-.783 9.47 6.215 17.398 14.711 19.92-2.896-1.8-4.916-4.93-5.253-8.571.496.072.998.124 1.512.124 6.06 0 10.97-5.048 10.97-11.277z"
}), React.createElement("path", {
  id: "6crib",
  d: "M744 3734.276c0-6.227-4.91-11.276-10.97-11.276-6.058 0-10.456 4.875-10.97 11.08-.783 9.47 6.215 17.398 14.711 19.92-2.896-1.8-4.915-4.93-5.253-8.571.496.072.998.124 1.512.124 6.06 0 10.97-5.048 10.97-11.277z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-694 -3723)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#6cria"
})), React.createElement("g", {
  transform: "translate(-694 -3723)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#6crib"
})));

var SvgQuote = function SvgQuote(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 31,
    viewBox: "0 0 50 31",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quote.a490547d.svg";
export { ForwardRef as ReactComponent };